__turbopack_context__.v({
  "cta": "Subnav-module-scss-module__Psdf5W__cta",
  "info-chip": "Subnav-module-scss-module__Psdf5W__info-chip",
  "menu__a": "Subnav-module-scss-module__Psdf5W__menu__a",
  "menu__li": "Subnav-module-scss-module__Psdf5W__menu__li",
  "menu__ul": "Subnav-module-scss-module__Psdf5W__menu__ul",
  "menu__ul-ctas": "Subnav-module-scss-module__Psdf5W__menu__ul-ctas",
  "nav-heading": "Subnav-module-scss-module__Psdf5W__nav-heading",
  "ns_button": "Subnav-module-scss-module__Psdf5W__ns_button",
  "subnav": "Subnav-module-scss-module__Psdf5W__subnav",
  "subnav-container": "Subnav-module-scss-module__Psdf5W__subnav-container",
});
